// import React, { useState } from "react";
// import { Box, Typography, Paper, Grid } from "@mui/material";

// const MAX_VALUE = 15000;

// export interface ProductItem {
//   name: string;
//   value: number;
//   color?: string;
// }

// export const products: ProductItem[] = [
//   { name: "Paracetamol", value: 12799, color: "#6A4DFF" },
//   { name: "Acetaminophen", value: 6000 },
//   { name: "Aspirin", value: 8000 },
//   { name: "Motrin", value: 4000 },
//   { name: "Actamin", value: 7000 },
//   { name: "Dolono", value: 12201 },
// ];

// const TopProductsCard: React.FC = () => {
//   const [selected, setSelected] = useState<string | null>(null);

//   return (
//     <Paper
//       sx={{
//         p: 2,
//         borderRadius: "16px",
//         border: "1px solid #E5E5E5",
//       }}
//     >
//       {/* Header */}
//       <Grid container justifyContent="space-between" mb={3}>
//         <Grid item>
//           <Typography variant="h6" sx={{ color: "#BAB8C8" }}>
//             Statistics
//           </Typography>
//           <Typography variant="h5" sx={{ fontWeight: 700 }}>
//             Top Products
//           </Typography>
//         </Grid>

//         <Grid item textAlign="right">
//           <Typography variant="body1" sx={{ color: "#BAB8C8" }}>
//             This week
//           </Typography>
//           <Typography variant="h5" sx={{ fontWeight: 700 }}>
//             50,000
//           </Typography>
//         </Grid>
//       </Grid>

//       {/* Bars */}
//       {products.map((item) => {
//         const widthPercent = (item.value / MAX_VALUE) * 100;
//         const isSelected = selected === item.name;

//         return (
//           <Grid
//             key={item.name}
//             container
//             alignItems="center"
//             mb={3}
//             onClick={() => setSelected(item.name)}
//             sx={{ cursor: "pointer", position: "relative" }}
//           >
//             {/* Tooltip Bubble (Figma green tag) */}
//             {isSelected && (
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: "-45px",
//                   left: `${widthPercent - 10}%`,
//                   transform: "translateX(-50%)",
//                   background: "#098963",
//                   color: "#fff",
//                   borderRadius: "12px",
//                   padding: "8px 16px",
//                   zIndex: 10,
//                   width: "160px",
//                   textAlign: "center",
//                   boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
//                 }}
//               >
//                 <Typography fontWeight={700} fontSize={14}>
//                   {item.name}
//                 </Typography>
//                 <Typography fontSize={13}>
//                   {item.value.toLocaleString()}
//                 </Typography>
//               </Box>
//             )}

//             {/* Bar Background */}
//             <Grid item xs={10}>
//               <Box
//                 sx={{
//                   //   background: isSelected ? "#E7D9FF" : "#D3D3DD",
//                   background: isSelected ? "#6A4DFF" : "#A2A2B3",

//                   py: 1,
//                   px: 2,
//                   borderRadius: 2,
//                   position: "relative",
//                 }}
//               >
//                 {/* Fill bar */}
//                 <Box
//                   sx={{
//                     width: `${widthPercent}%`,
//                     background: isSelected ? "#6A4DFF" : "#A2A2B3",
//                     height: 16,
//                     borderRadius: 2,
//                     transition: "0.3s",
//                   }}
//                 ></Box>

//                 {/* Label */}
//                 <Typography
//                   sx={{
//                     position: "absolute",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     color: "#000",
//                     fontWeight: 600,
//                   }}
//                 >
//                   {item.name}
//                 </Typography>
//               </Box>
//             </Grid>

//             {/* Value Text */}
//             <Grid item xs={2} textAlign="right">
//               <Typography sx={{ fontWeight: 600 }}>
//                 {item.value.toLocaleString()}
//               </Typography>
//             </Grid>
//           </Grid>
//         );
//       })}

//       {/* X-Axis Labels */}
//       <Grid container justifyContent="space-between" mt={4}>
//         {["0", "2k", "5k", "10k", "15k"].map((l) => (
//           <Typography key={l} sx={{ color: "#888", fontWeight: 600 }}>
//             {l}
//           </Typography>
//         ))}
//       </Grid>
//     </Paper>
//   );
// };

// export default TopProductsCard;





import React, { useState, useEffect } from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import http from "../../commonFunctions/httpClient";
import { getLocalValue, LoacalVariables } from "../../commonFunctions/CommonFunctions";

const MAX_VALUE = 15000;

export interface ProductItem {
  name: string;
  value: number;
  color?: string;
  imageUrl?: string;
  productId?: string;
}

export const TopProductsCard: React.FC = () => {
  const [selected, setSelected] = useState<string | null>(null);
  const [products, setProducts] = useState<ProductItem[]>([]);
  const [vendorId, setVendorId] = useState<string>("");
  const [loading, setLoading] = useState(true);

  // Get vendorId from localStorage
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    setVendorId(userId || "");
  }, []);

  // Fetch top selling products
  useEffect(() => {
    const fetchProducts = async () => {
      if (!vendorId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        console.log("📡 FETCHING TOP PRODUCTS FOR VENDOR:", vendorId);
        const response: any = await http.get(`/pharmacy/products/vendor/${vendorId}/top-selling`);
        console.log("📦 API RESPONSE:", response);
        
        if (response?.success && Array.isArray(response.data)) {
          const data: ProductItem[] = response.data.map((item: any) => ({
            name: item.product_Name || item.productName || "Unknown Product",
            value: item.totalSold || 0,
            imageUrl: item.product_Image_Url || item.productImageUrl || "",
            productId: item.product_Id || item.productId || "",
            color: "#6A4DFF"
          }));
          setProducts(data);
        } else {
          setProducts([]);
        }
      } catch (error: any) {
        console.error("💥 API ERROR:", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [vendorId]);

  if (loading) {
    return (
      <Paper sx={{ p: 2, borderRadius: "16px", border: "1px solid #E5E5E5" }}>
        <Typography>Loading top products...</Typography>
      </Paper>
    );
  }

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: "16px",
        border: "1px solid #E5E5E5",
      }}
    >
      {/* Header */}
      <Grid container justifyContent="space-between" mb={3}>
        <Grid item>
          <Typography variant="h6" sx={{ color: "#BAB8C8" }}>
            Statistics
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Top Products
          </Typography>
        </Grid>

        <Grid item textAlign="right">
          <Typography variant="body1" sx={{ color: "#BAB8C8" }}>
            This week
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {products.reduce((sum, p) => sum + p.value, 0).toLocaleString()}
          </Typography>
        </Grid>
      </Grid>

      {/* Bars */}
      {products.map((item) => {
        const widthPercent = Math.min((item.value / MAX_VALUE) * 100, 100);
        const isSelected = selected === item.name;

        return (
          <Grid
            key={item.productId || item.name}
            container
            alignItems="center"
            mb={3}
            onClick={() => setSelected(item.name)}
            sx={{ cursor: "pointer", position: "relative" }}
          >
            {/* Tooltip Bubble */}
            {isSelected && (
              <Box
                sx={{
                  position: "absolute",
                  top: "-45px",
                  left: `${widthPercent - 10}%`,
                  transform: "translateX(-50%)",
                  background: "#098963",
                  color: "#fff",
                  borderRadius: "12px",
                  padding: "8px 16px",
                  zIndex: 10,
                  width: "160px",
                  textAlign: "center",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                }}
              >
                <Typography fontWeight={700} fontSize={14}>
                  {item.name}
                </Typography>
                <Typography fontSize={13}>
                  {item.value.toLocaleString()}
                </Typography>
              </Box>
            )}

            {/* Bar Background */}
            <Grid item xs={10}>
              <Box
                sx={{
                  background: isSelected ? "#6A4DFF" : "#A2A2B3",
                  py: 1,
                  px: 2,
                  borderRadius: 2,
                  position: "relative",
                }}
              >
                {/* Fill bar */}
                <Box
                  sx={{
                    width: `${widthPercent}%`,
                    background: isSelected ? "#6A4DFF" : "#A2A2B3",
                    height: 16,
                    borderRadius: 2,
                    transition: "0.3s",
                  }}
                ></Box>

                {/* Label */}
                <Typography
                  sx={{
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "14px",
                    textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
                  }}
                >
                  {item.name.length > 20 ? `${item.name.substring(0, 20)}...` : item.name}
                </Typography>
              </Box>
            </Grid>

            {/* Value Text */}
            <Grid item xs={2} textAlign="right">
              <Typography sx={{ fontWeight: 600 }}>
                {item.value.toLocaleString()}
              </Typography>
            </Grid>
          </Grid>
        );
      })}

      {/* Show empty state if no products */}
      {products.length === 0 && (
        <Box textAlign="center" py={4}>
          <Typography sx={{ color: "#BAB8C8" }}>
            No top-selling products found
          </Typography>
        </Box>
      )}

      {/* X-Axis Labels */}
      <Grid container justifyContent="space-between" mt={4}>
        {["0", "2k", "5k", "10k", "15k"].map((l) => (
          <Typography key={l} sx={{ color: "#888", fontWeight: 600 }}>
            {l}
          </Typography>
        ))}
      </Grid>
    </Paper>
  );
};

export default TopProductsCard;
